import React, { useEffect, useState } from 'react'
import styles from "../../pages/OnBoarding/UserOnboarding.module.css";
import SlideUpWrapper from '../Transitions/SlideUpWrapper';
import pass from "./LoginForm.module.css"
import Loader from '../Loader';
import RightContent1 from './login_right';
import BtnLoader from '../BtnLoader';
import { GET_MFA, GET_OTP, MFA_VERIFY, UPDATE_PHONE, VERIFY_OTP } from '../../Utils/constant';
import { Delay, resetTimer, Timer } from '../../Utils/helper';
import API from "../../ApiConfig";
import cogoToast from 'cogo-toast-react-17-fix';
import { useNavigate } from 'react-router-dom';
import OtpInputs from '../../Utils/OtpInputs';


const VerifyOTP = () => {
const [loading, setLoading]=useState(false)
    const [otp, setOtp]=useState("")
    const navigate=useNavigate()

    const VerifyData=JSON.parse(localStorage.getItem("VerifyData"))  
    const [OtpTimer, setOtpTimer] = useState(0)
    const [OTPkey, setOTPKey] = useState(Date.now())

    const handleSubmit = (e) => {
        e.preventDefault();
        if(ValidateOtp()){
        setLoading(true); // Set loading state to true
        let formData = { identifier: VerifyData.email, otp: otp };
        API.post(MFA_VERIFY, formData)
          .then((data) => {
            let res = data.data;
            if (res.data) {
              resetTimer();
              navigate(VerifyData?.forgot_password_url);
            } else {
              cogoToast.error("Incorrect OTP. Please check again or resend OTP");
            }
          })
          .catch((err) => {
            cogoToast.error(err.response.data.detail);
          })
          .finally(() => {
            setLoading(false);
          });
        }

      }
        const GetMfaOtp = (data) => {
            setOtp(data);
          }

          
        const getOTP = () => {
            let formData = { user_id: VerifyData.user_id };
            API.post(GET_MFA, formData)
              .then((data) => {
                let res = data.data;
                if (res.success == true) {
                  cogoToast.success("OTP re-sent to " + VerifyData.phone_no);
                  setOTPKey(Date.now())
                }
              })
              .catch((err) => {
                cogoToast.error(err.response.data.message);
              });
          }
     const ValidateOtp=()=>{
        if(otp===""){
            cogoToast.error("Please Enter Phone Number!!")
            return false;
            }
        return true;
    }
    useEffect(()=>{
        if(VerifyData){
            getOTP()
        }
    },[])

  return (
    <SlideUpWrapper direction="slide-left">
        <div className={styles.userOnboarding}>
            <Loader isOpen={loading}/>
            <form className={pass.leftContent} onSubmit={handleSubmit}>
                <div className={styles.progressForm}>
                    <div className={styles.progressForm1}>
                        <div className={pass.form}>                            
                            <div className={styles.form1}>
                                <img src="/passwordLogo.svg" alt="passwordLogo.svg" className={pass.passwordLogo}/>
                                <div className={styles.headingHelperText}>
                                    <h3 className={pass.Resetheading}>Verify OTP</h3>
                                    <div className={pass.supportingText}>
                                        <p className={styles.weMessagedASixDigitCodeT}>
                                        <span className={pass.weMessagedA}>Verify your phone no. before changing password</span>
                                        </p>
                                        <div className={pass.inputdiv}>
                                            <div className={styles.codeInputs}>
                                                <OtpInputs length={6} getOtp={GetMfaOtp} />
                                                <Timer m={0.5} getOTP={getOTP} key={OTPkey} />
                                                
                                                
                                            </div>
                                        </div>
                                        {otp?
                                        <button type="submit" disabled={loading} className="primaryBtn" style={{marginTop:"10px"}}>
                                            {loading ? "Submitting..." : "Submit"}
                                        </button> :
                                        <button style={{ backgroundColor: "lightgray", cursor: "not-allowed", marginTop:"10px" }} disabled={!otp || loading} className="DisableprimaryBtn">
                                            {loading ? "Submitting..." : "Submit"}
              </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={pass.copyright}>
                Copyright 2026 AuthBridge, All Rights Reserved.
            </div>
            </form>
      <RightContent1/>
        </div>
        </SlideUpWrapper>
  )
}

export default VerifyOTP